export default __webpack_public_path__ + "static/yoga-meditation-0169c12724181a35b1e5ad6681a417c8.png";